import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { CME_DIEU_DUONG_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

const CMEDieuDuongEventAddEditModal = ({ isOpen, handleClose, data, refetch }) => {
    const upsertFunc = useMutation((payload) => Post(CME_DIEU_DUONG_API.UPSERT, null, payload));
    const [reports, setReports] = useState([{ tenBaoCao: '', baoCaoVien: '' }]);

    useEffect(() => {
        if (isOpen) {
            if (data) {
                const titles = (data.tenBaoCao || '').split('; ');
                const authors = (data.baoCaoVien || '').split('; ');
                const loadedReports = [];
                const maxLength = Math.max(titles.length, authors.length);
                for (let i = 0; i < maxLength; i++) {
                    loadedReports.push({
                        tenBaoCao: titles[i] || '',
                        baoCaoVien: authors[i] || ''
                    });
                }
                setReports(loadedReports.length > 0 ? loadedReports : [{ tenBaoCao: '', baoCaoVien: '' }]);
            } else {
                setReports([{ tenBaoCao: '', baoCaoVien: '' }]);
            }
        }
    }, [data, isOpen]);

    const initialValues = {
        tenKhoaDaoTao: data?.tenKhoaDaoTao || '',
        maKhoaDaoTao: data?.maKhoaDaoTao || '',
        tieuMucId: data?.tieuMucId || '00000000-0000-0000-0000-000000000000',
        tuNgay: data?.tuNgay ? moment(data.tuNgay).format('YYYY-MM-DD') : '',
        denNgay: data?.denNgay ? moment(data.denNgay).format('YYYY-MM-DD') : '',
        diaDiem: data?.diaDiem || '',
        soGioTinChi: data?.soGioTinChi || 1,
        chuTri: data?.chuTri || ''
    };

    const validationSchema = Yup.object().shape({
        tenKhoaDaoTao: Yup.string().required('Bắt buộc nhập tên khóa đào tạo'),
        tuNgay: Yup.string().required('Bắt buộc chọn ngày bắt đầu'),
        denNgay: Yup.string().required('Bắt buộc chọn ngày kết thúc'),
        soGioTinChi: Yup.number().min(0.1, 'Số giờ tín chỉ phải lớn hơn 0').required('Bắt buộc nhập số giờ tín chỉ')
    });

    const handleSubmit = (values) => {
        const validReports = reports.filter(r => r.tenBaoCao.trim() !== '' || r.baoCaoVien.trim() !== '');

        const payload = {
            ...data,
            ...values,
            tenBaoCao: validReports.map(r => r.tenBaoCao.trim()).join('; '),
            baoCaoVien: validReports.map(r => r.baoCaoVien.trim()).join('; ')
        };

        upsertFunc.mutate(payload, {
            onSuccess: (res) => {
                if (res.id || res.status === 200) {
                    toast.success("Lưu thông tin thành công!");
                    refetch();
                    handleClose();
                } else {
                    toast.error("Có lỗi xảy ra khi lưu thông tin.");
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra.");
            }
        });
    };

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{data ? 'Chỉnh sửa khóa đào tạo Điều dưỡng' : 'Tạo khóa đào tạo mới'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Tên khóa đào tạo / Hoạt động sinh hoạt <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="tenKhoaDaoTao"
                                            value={values.tenKhoaDaoTao}
                                            onChange={handleChange}
                                            isInvalid={touched.tenKhoaDaoTao && !!errors.tenKhoaDaoTao}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenKhoaDaoTao}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Mã khóa (nếu có)</Form.Label>
                                        <Form.Control
                                            name="maKhoaDaoTao"
                                            value={values.maKhoaDaoTao}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Hình thức <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            value="Tham gia hoạt động sinh hoạt chuyên môn - Phân tích ca bệnh"
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Từ ngày <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="tuNgay"
                                            value={values.tuNgay}
                                            onChange={handleChange}
                                            isInvalid={touched.tuNgay && !!errors.tuNgay}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tuNgay}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Đến ngày <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="denNgay"
                                            value={values.denNgay}
                                            onChange={handleChange}
                                            isInvalid={touched.denNgay && !!errors.denNgay}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.denNgay}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Số giờ tín chỉ <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="soGioTinChi"
                                            value={values.soGioTinChi}
                                            onChange={handleChange}
                                            isInvalid={touched.soGioTinChi && !!errors.soGioTinChi}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.soGioTinChi}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Địa điểm tổ chức</Form.Label>
                                        <Form.Control
                                            name="diaDiem"
                                            value={values.diaDiem}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Chủ trì</Form.Label>
                                        <Form.Control
                                            name="chuTri"
                                            value={values.chuTri}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                
                                <Col md={12} className="mt-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                                        <span className="font-weight-bold text-primary" style={{ fontSize: '0.95rem' }}>
                                            <i className="fas fa-file-medical mr-1"></i>Danh sách bài báo cáo & Báo cáo viên
                                        </span>
                                        <Button 
                                            variant="outline-success" 
                                            size="sm" 
                                            onClick={() => setReports(prev => [...prev, { tenBaoCao: '', baoCaoVien: '' }])}
                                            style={{ borderRadius: '6px' }}
                                        >
                                            <i className="fas fa-plus mr-1"></i>Thêm báo cáo
                                        </Button>
                                    </div>
                                    {reports.map((report, idx) => (
                                        <Row key={idx} className="align-items-end mb-2">
                                            <Col md={6}>
                                                <Form.Group className="mb-2">
                                                    <Form.Label style={{ fontSize: '0.85rem' }} className="font-weight-bold">Tên bài báo cáo #{idx + 1}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={report.tenBaoCao}
                                                        onChange={(e) => {
                                                            const newTitle = e.target.value;
                                                            setReports(prev => prev.map((r, i) => i === idx ? { ...r, tenBaoCao: newTitle } : r));
                                                        }}
                                                        placeholder="Nhập tên bài báo cáo..."
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={5}>
                                                <Form.Group className="mb-2">
                                                    <Form.Label style={{ fontSize: '0.85rem' }} className="font-weight-bold">Báo cáo viên #{idx + 1}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={report.baoCaoVien}
                                                        onChange={(e) => {
                                                            const newAuthor = e.target.value;
                                                            setReports(prev => prev.map((r, i) => i === idx ? { ...r, baoCaoVien: newAuthor } : r));
                                                        }}
                                                        placeholder="Nhập tên báo cáo viên..."
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={1} className="text-right">
                                                <Button 
                                                    variant="outline-danger" 
                                                    size="sm" 
                                                    className="mb-2" 
                                                    disabled={reports.length <= 1}
                                                    onClick={() => setReports(prev => prev.filter((_, i) => i !== idx))}
                                                    style={{ padding: '6px 10px', borderRadius: '6px' }}
                                                >
                                                    <i className="fas fa-trash-alt"></i>
                                                </Button>
                                            </Col>
                                        </Row>
                                    ))}
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Đóng</Button>
                            <Button variant="primary" type="submit" disabled={upsertFunc.isLoading}>
                                {upsertFunc.isLoading ? 'Đang lưu...' : 'Lưu thông tin'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default CMEDieuDuongEventAddEditModal;
